import VueRouter, { Route } from 'vue-router';
import { isModalOpen } from '../../../util';
import { RouteName } from '../../../routes/routes.constants';

/**
 * Checks if current route is a child of target route.
 * @param current
 * @param target
 */
export function isIncludedRoute(current: Route, target: Route): boolean {
    const isHashSame = !target.hash || current.hash === target.hash;
    return (
        removeTrailing(current.path).startsWith(removeTrailing(target.path)) &&
        isHashSame &&
        queryIncludes(current.query, target.query)
    );
}

function queryIncludes(
    current: Route['query'],
    target: Route['query'],
): boolean {
    for (const key in target) {
        if (!(key in current)) {
            return false;
        }
    }

    return true;
}

function removeTrailing(path: string) {
    if (!path) {
        return '';
    }

    if (path.endsWith('/')) {
        return path.substr(0, path.length - 1);
    }

    return path;
}

/**
 * Checks if the current route is active,
 * also if it's a modal route on desktop
 * @param name the currect route name
 * @param route
 * @param router
 */
export function isRouteActive(
    name: RouteName,
    route: Route,
    router: VueRouter,
) {
    if (route.name === name) {
        return true;
    }

    return isModalOpen(name, route.query, router);
}
